import * as React from "react";
import { Snackbar, Alert, LinearProgress, Box } from "@mui/material";

export default function TimedSnackbar({ a, i, onClose }) {
  const total = a.autoHideMs ?? 4000;
  const [progress, setProgress] = React.useState(0);
  const startRef = React.useRef(Date.now());
  const accRef = React.useRef(0); // accumulated ms when paused/resumed
  const rafRef = React.useRef();

  React.useEffect(() => {
    const tick = () => {
      const elapsed = Date.now() - startRef.current + accRef.current;
      const pct = Math.min(100, (elapsed / total) * 100);
      setProgress(pct * 1.11);
      if (elapsed >= total) onClose();
      else rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [total, onClose]);
  return (
    <Snackbar
      open
      key={a.id}
      autoHideDuration={total} // still let Snackbar auto-close
      onClose={(_, reason) => {
        if (reason !== "clickaway") onClose();
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      style={{ bottom: 10 + i * 70 }}
    >
      <Alert
        onClose={onClose}
        severity={a.severity || "info"}
        variant="filled"
        sx={{ position: "relative", p: 1.5, pt: 1.25, borderRadius: 10 }}
      >
        {a.message}

        {/* duration bar */}
        <Box
          sx={{
            position: "absolute",
            left: 23,
            right: 23,
            bottom: 0,
          }}
        >
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 3,
              borderBottomLeftRadius: 4,
              borderBottomRightRadius: 4,
              "& .MuiLinearProgress-bar": { borderRadius: 0 },
              opacity: 0.9,
              transform: "scaleX(-1)",
            }}
            color={
              a.severity === "error"
                ? "error"
                : a.severity === "warning"
                ? "warning"
                : a.severity === "success"
                ? "success"
                : "info"
            }
          />
        </Box>
      </Alert>
    </Snackbar>
  );
}
